import { Link, useTranslation } from "gatsby-plugin-react-i18next";
import React, { FunctionComponent } from "react";

import BodyText from "./BodyText";
import { LinkCta } from "./LinkCta";
import Title from "./Title";

type KeywordLinkProps = {
  title: string;
  description?: string;
  to: string;
};

const KeywordLink: FunctionComponent<KeywordLinkProps> = ({
  to,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Link to={to}>
      <Title>{title}</Title>
      {description && <BodyText mb={2}>{description}</BodyText>}
      <LinkCta text={t("common:findMore")} />
    </Link>
  );
};

export default KeywordLink;
